import TRADEMACH_EXT_1 from "./TRADEMACH_EXT_1";
export default {
  TRADEMACH_EXT_1,
};
